import React, { useState } from 'react';
import { H2, BackIcon, BackIconGreen } from '../reusable-components';
import { useTranslation } from "react-i18next";
import NavBar from '../navbar/navbar';
import { useHistory } from "react-router-dom";
import { IsComeOn, IsLeo, IsPaf, IsRightToLeftTheme, themeC } from '../theme/themehelper';
import { Button, Grid, SxProps, Theme, useMediaQuery } from '@mui/material';
import { useApi } from '../api/apiContext';

const Help: React.FC = () => {

    const [triggerError, setTriggerError] = useState<boolean>(false);
    const [api] = useApi();

    if (triggerError) {
        throw new Error("Simulated error triggered by button!");
    }

    const history = useHistory();
    const goBack = () => {
        history.goBack()
    }
    const { t } = useTranslation(['translation', 'rules']);
    const isMobileScreen = useMediaQuery('(max-width: 950px)');

    let extraClass: string = "";

    if (IsRightToLeftTheme(window.theme)) {
        extraClass = "rtl";
    }

    const styleWrapper: SxProps<Theme> = {        
        flexDirection: 'column',
        alignItems: 'center',
        bottomMargin: '40px',
        whiteSpace: 'pre-wrap',
    };

    const styleFlexStart: SxProps<Theme> = {        
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '80%',
        marginTop: '40px',
        marginBottom: '40px',
    };

    const styleHelpParagraph: SxProps<Theme> = {        
        width: '100%',
        flexDirection: 'row',
        fontFamily: 'var(--font-body)',
        fontSize: '14px',
        color: 'var(--text-black-dark-background)',
        opacity: window.theme === themeC.Hard ? 0.6 : 1,
        marginBlockStart: '1em',
        marginBlockEnd: '1em',
        marginInlineStart: '0px',
        marginInlineEnd: '0px',
    };

    const styleRtl: SxProps<Theme> = {
        textAlign: 'right',
        direction: 'rtl',
    };

    const styleHelpHeader: SxProps<Theme> = {
        fontFamily: 'var(--font-body)',
        color: 'var(--font-title-color)',
        fontSize: '15px',
        lineHeight: '16px',
        fontWeight: 'bold',
        margin: '0px 0px 0px 0px',
        display: 'flex',
        width: '100%',
        flexDirection: 'var(--flex-direction)',
    };

    const styleGoBack: SxProps<Theme> = {        
        flexDirection: 'row',
        margin: '10px 0px 10px 0px',
        alignItems: 'flex-start',
        width: '90%',
    };

    const styleGoBackButton: SxProps<Theme> = {        
        flexDirection: 'row',
        margin: '10px 0px 10px 0px',
    };

    let q1q: string = t('rules:faq.q1.question');
    let q1a: string = t('rules:faq.q1.answer');

    if (window.theme === themeC.Lyllo) {
        q1q = 'Vad är Lyllotipset?';
        q1a = 'Alla insatser hamnar i en gemensam pott, och du vinner om du tippar rätt resultat. En liten avgift dras, resten delas mellan vinnarna. Ju fler som spelar – desto större vinst!';
    }

    const greenFaq = [
        { q: 'Vad är Unibet 1X2?', a: 'Unibet 1X2 är ett poolspel där du tippar utgången i flera matcher. Alla spelares insatser samlas i en gemensam pott som delas mellan vinnarna.' },
        { q: 'Vad är en omgång?', a: 'En omgång består av ett antal utvalda matcher där du tippar utgången i varje match – hemmavinst (1), oavgjort (X) eller bortavinst (2). Omgångar innehåller vanligtvis 8, 12 eller 13 matcher.' },
        { q: 'Hur fungerar vinstgrupper?', a: 'Det finns 3 vinstgrupper i omgångar med 12 eller 13 matcher. Det finns 1 vinstgrupp i omgångar med 6, 7, 8 eller 9 matcher.' },
        { q: 'Hur lägger jag ett spel?', a: 'Du väljer ett utfall i varje match. Du kan även markera flera utfall per match för att öka dina chanser. Antalet rader (och därmed insatsen) ökar beroende på hur många val du gör.' },
        { q: 'Hur vinner jag?', a: 'Du vinner genom att få tillräckligt många rätt enligt vinstplanen för omgången. Vinsten delas med andra spelare som också har rätt resultat.' },
        { q: 'Vad är Auto Picks?', a: 'Auto Picks är ett snabbt sätt att lägga ett spel där valen görs automatiskt åt dig. Du kan välja mellan mer sannolika utfall eller alternativ med högre risk och potentiellt högre utdelning.' },
        { q: 'Vad är ett reducerat system?', a: 'Ett reducerat system innebär att du spelar färre rader än ett fullt matematiskt system. Det gör spelet billigare, men minskar också sannolikheten att få alla rätt.' },
        { q: 'Kan jag ladda upp egna rader?', a: 'Ja. Gå till "info" på den aktuella omgången och klicka sedan på knappen \'Filuppladdning\' för att spela dina egna system.' },
    ];

    let theme: string = window.theme;

    return (
        <>
            <NavBar whichToUnderline="6" balanceUpdateId={0}/>
            <Grid container direction="column" alignItems="center" sx={styleWrapper}>
                {isMobileScreen &&
                    <Grid sx={styleGoBack}>
                        <Grid sx={styleGoBackButton} id={'go-back-button'} onClick={() => goBack()}>
                            <div>{theme === themeC.Green ? BackIconGreen() : BackIcon("var(--text-black-dark-background)")}</div>
                            {theme !== themeC.Green && <div className={'bold'}>{t('go_back')}</div>}
                        </Grid>
                    </Grid>
                }

                {api !== undefined && api._links.me.href.indexOf("demo") > -1 &&
                    <Button onClick={() => { setTriggerError(true) }}>Raise Error</Button>
                }

                <H2>{t('rules:faq.title')}</H2>
                <Grid sx={styleFlexStart}>
                    {window.theme === themeC.Green ? (
                        <>
                            {greenFaq.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid sx={styleHelpHeader}>{item.q}</Grid>
                                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{item.a}</Grid>
                                </React.Fragment>
                            ))}
                        </>
                    ) : (
                        <>
                    <Grid sx={styleHelpHeader}>{q1q}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{q1a}</Grid>

                    <Grid sx={styleHelpHeader}>{t('rules:faq.q2.question')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q2.answer')}</Grid>

                    <Grid sx={styleHelpHeader}>{t('rules:faq.q3.question')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q3.answer')}</Grid>

                    <Grid sx={styleHelpHeader}>{t('rules:faq.q4.question')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q4.answer')}</Grid>

                    <Grid sx={styleHelpHeader}>{t('rules:faq.q5.question')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q5.answer')}</Grid>

                    <Grid sx={styleHelpHeader}>{t('rules:faq.q6.question')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q6.answer')}</Grid>

                    <Grid sx={styleHelpHeader}>{t('rules:faq.q7.question')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q7.answer')}</Grid>

                    <Grid sx={styleHelpHeader}>{t('rules:faq.q8.question')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q8.answer')}</Grid>

                    {IsLeo(window.theme) && !IsComeOn(window.theme) && !IsPaf(window.theme) &&
                        <>
                            <Grid sx={styleHelpHeader}>{t('rules:faq.q9.question')}</Grid>
                            <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:faq.q9.answer')}</Grid>
                        </>
                    }
                        </>
                    )}

                </Grid>
                <H2>{t('rules:terms.title')}</H2>
                <Grid sx={styleFlexStart}>
                    <Grid sx={styleHelpHeader}>{t('rules:terms.p1.title')}</Grid>
                    <br />
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.1</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p11')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.2</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p12')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.3</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p13')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.4</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p14')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.5</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p15')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.6</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p16')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.7</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p17')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.8</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p18')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.9</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p19')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.10</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p110')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.11</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p111')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.12</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p112')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.13</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p113')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.14</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p114')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.15</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p115')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.16</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p116a')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p116b')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p116c')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p116d')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p116e')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.17</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p117')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.18</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p118')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.19</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p119')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.20</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p120')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.21</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p121')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>1.22</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p1.p122')}</Grid>
                    <br />
                    <Grid sx={styleHelpHeader}>{t('rules:terms.p2.title')}</Grid>
                    <br />
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>2.1</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.p21')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>2.2</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.p22')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>2.3</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.p23')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>2.4</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.p24')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>2.5</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.p25')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>2.6</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.p26')}</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>2.7</Grid>
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.p27')}</Grid>                    
                    <Grid sx={{ ...styleHelpParagraph, ...(extraClass === "rtl" ? styleRtl : {}) }}>{t('rules:terms.p2.amendment')}</Grid>
                </Grid>

            </Grid>

        </>
    );
}

export default Help;